/**
 * Get an array of regexes that match auth URLs.
 *
 * This gives the default regexes we use to determine if something should be
 * considered an auth URL by our URL building logic.
 */
export const DefaultAuthUrls = (): Array<RegExp> => [
    /^\/signup.*/,
    /^\/logout.*/,
    // DIST-2234: For the login URL we can't just use
    // /^\/login.*/ because that will ignore the
    // continue URL for our Clever and Classlink redirect pages
    // (/login/clever/redirect and /login/classlink)
    /^\/login(?!\/clever|\/classlink).*/,
    /^\/$/,
];
